





























import Vue, { PropType } from "vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import LayoutColumnSingle from "@/components/Atoms/Layout/ColumnSingle/index.vue";
import EventHeader from "@/components/Molecules/EventHeader/index.vue";
import EventExperienceCardHeader from "./Molecules/EventExperienceCardHeader/index.vue";
import EventExperienceCardList from "./Molecules/EventExperienceCardList/index.vue";
import ClipMixin from "@/components/Mixins/Clip/index";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "EventExperiences",
  components: {
    LoadingView,
    EventHeader,
    EventExperienceCardHeader,
    EventExperienceCardList,
    LayoutColumnSingle
  },
  mixins: [ClipMixin],
  props: {
    eventExperiences: {
      type: Array as PropType<Props["eventExperiences"]>,
      required: true,
      default: () => []
    },
    company: {
      type: Object as PropType<Props["company"]>,
      default: undefined
    },
    graduateYear: {
      type: Number as PropType<Props["graduateYear"]>,
      default: 0
    },
    headerTitle: {
      type: String as PropType<Props["headerTitle"]>,
      required: true
    },
    isLoading: {
      type: Boolean as PropType<Props["isLoading"]>,
      required: true,
      default: false
    }
  }
});
